import styled           from "styled-components";
import {SectionWrapper} from "../../shared/Styles/Wrappers";

export const Container = styled.div`
    max-width: 100vw;
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
`;

export const Header = styled.h2`
    font-size: 8rem;
    line-height: 1.08;
    color: ${({ color }) => color ? color : "#fff"};
    font-weight: 800;
    margin: 12px 0 24px 0;

    span {
        color: ${({ spanColor }) => spanColor ? spanColor : "#fff"};
        text-decoration: underline;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: 6.2rem;
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        font-size: 4.58rem;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 3.6rem;
        margin: 12px 0 24px 0;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) and (orientation: landscape) {
        font-size: 2.5rem !important;
        margin: 12px 0 18px 0;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
        font-size: 3.2rem;
    }
`;

export const Image = styled.div`
    width: 100%;
    height: 100%;

    .gatsby-image-wrapper {
        width: 100%;
        height: 100%;
    }
`;

export const Mask = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({color}) => (color ? color : 'rgba(93, 0, 225, 0.60)')};
    z-index: 2;
    opacity: 0.9;
`;

export const TextBox = styled(SectionWrapper)`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    z-index: 3;
`;

export const TextWrapper = styled.div`
    max-width: 1200px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
`;

export const Title = styled.h1`
    font-size: 1.6rem;
    color: ${({ color }) => color ? color : "#fff"};
    text-transform: uppercase;
    font-weight: 600;
    display: none;
    
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: 1.4rem;
    }
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 1.2rem;
        display: block;
    }
`;

export const Text = styled.p`
    font-size: ${({ biggerSize }) => biggerSize ? "1.8rem" : "1.6rem"};
    line-height: 1.6;
    color: ${({ color }) => color ? color : "#fff"};
    font-weight: 400;
    max-width: 850px;
    width: 100%;

    a {
        display: inline;
        text-decoration: underline;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: ${({ biggerSize }) => biggerSize ? "1.6rem" : "1.4rem"};
        max-width: 700px;
    }

    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        font-size: ${({ biggerSize }) => biggerSize ? "1.4rem" : "1.2rem"};
        max-width: 650px;
    }

    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        max-width: 500px;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) and (orientation: landscape) {
        line-height: 1.4;
        font-size: 1.2rem;
        padding-right: 40px;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
        max-width: 100%;
    }
`;

export const ButtonWrapper = styled.div`
    margin-top: 48px;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone_big}) {
        margin-top: 24px;
    }
`;

export const LogoWrapper = styled.div`
    height: 50px;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop_big}) {
        height: 84px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        height: 76px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop_small}) {
        height: 64px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) and (orientation: landscape) {
        height: 40px;

        img {
            display: block;
            margin: 0 auto;
        }
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.phone_big}) and (orientation: portrait) {
        height: 50px;

        img {
            display: block;
            margin: 0 auto;
        }
    }
`;

export const Icon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
